import { useRouteMatch } from 'react-router-dom'
import { useMemo } from 'react'
import { LOUNGE_BOARD_SERVICE_TYPE } from '../loungeBoardContants'

const LoungeBoardQna = () => {
  const match = useRouteMatch([
    '/:accountId(\\d+)/channels/:channelId(\\d+)',
    '/:accountId(\\d+)/documents/add/:channelId(\\d+)',
    '/:accountId(\\d+)/ads/campaigns/:campaignId(\\d+)/groups/:adGroupId(\\d+)/creatives/save-as/:creativeId(\\d+)',
    '/:accountId(\\d+)/ads/campaigns/:campaignId(\\d+)/groups/:adGroupId(\\d+)',
    '/:accountId(\\d+)/ads/campaigns/:campaignId(\\d+)',
    '/:accountId(\\d+)/creatives/add/:creativeId(\\d+)',
    '/:accountId(\\d+)/creatives/:creativeId(\\d+)',
    '/:accountId(\\d+)',
  ])
  const href = useMemo(() => {
    const { accountId, channelId, campaignId, adGroupId, creativeId } =
      match?.params || {}
    const targetTypes = []
    const targetIds = []
    const targetMap = {
      AD_ACCOUNT: accountId,
      BIZ_CHANNEL: channelId,
      CAMPAIGN: campaignId,
      AD_GROUP: adGroupId,
      CREATIVE: creativeId,
    }
    Object.entries(targetMap).forEach(([type, id]) => {
      if (id) {
        targetTypes.push(type)
        targetIds.push(id)
      }
    })
    return `${
      process.env.REACT_APP_LOUNGE_BOARD_HOST
    }/post/list?serviceType=${LOUNGE_BOARD_SERVICE_TYPE}${
      targetTypes.length > 0 ? `&targetType=${targetTypes.join(',')}` : ''
    }${targetIds.length > 0 ? `&targetId=${targetIds.join(',')}` : ''}`
  }, [match])
  return (
    <li>
      <a
        href={href}
        rel="noopener noreferrer"
        target="_blank"
        className="link_gnb">
        문의게시판
      </a>
    </li>
  )
}
export default LoungeBoardQna
